











































































import {defineComponent, PropType} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import TableInput from '@/tasks/components/inputs/TableInput.vue';
import STextarea from '@/common/components/STextarea.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default defineComponent({
  name: 'Chem51LBProject1FS2Safety',
  components: {TableInput},
  mixins: [DynamicQuestionMixin()],
  props: {
    isMarking: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      inputs: {
        rows: [
          {
            chemicalName: '',
            GhsSymbol1: '',
            precautionaryStatement1: '',
            GhsSymbol2: '',
            precautionaryStatement2: '',
          },
        ],
        wasteTable: [
          {
            solidWaste: '',
            liquidWaste: '',
            glassWaste: '',
            trashCan: '',
          },
        ],
        safetyMoment: '',
      },
      attachments: [] as File[],
      columns: [
        {
          label: 'Chemical Name (one per row)',
          component: STextarea,
          prop: 'chemicalName',
          width: '30%',
        },
        {label: 'GHS Symbol #1', component: STextarea, prop: 'GhsSymbol1', width: '10%'},
        {
          label: 'Associated Precautionary Statement',
          component: STextarea,
          prop: 'precautionaryStatement1',
          width: '25%',
        },
        {label: 'GHS Symbol #2', component: STextarea, prop: 'GhsSymbol2', width: '10%'},
        {
          label: 'Associated Precautionary Statement',
          component: STextarea,
          prop: 'precautionaryStatement2',
          width: '25%',
        },
      ],
      wasteColumns: [
        {label: 'Solid waste', component: STextarea, prop: 'solidWaste', width: '25%'},
        {label: 'Liquid waste', component: STextarea, prop: 'liquidWaste', width: '25%'},
        {label: 'Glass waste', component: STextarea, prop: 'glassWaste', width: '25%'},
        {label: 'Trash can', component: STextarea, prop: 'trashCan', width: '25%'},
      ],
    };
  },
  methods: {},
  computed: {
    imageName(): string {
      return prefixPublicAsset('/img/assignments/GHS_Symbols.png');
    },
    solidLiquidWasteImageName(): string {
      return prefixPublicAsset('/img/assignments/solidLiquidWaste.png');
    },
    glassWasteImageName(): string {
      return prefixPublicAsset('/img/assignments/glassWaste.png');
    },
    trashCanImageName(): string {
      return prefixPublicAsset('/img/assignments/trashCan.png');
    },
    attachments(): File[] {
      return [...this.attachments];
    },
  },
});
